import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startSaveEmpresa } from '../../actions/empresas';
import { openModalBottom, setMenuLateral } from '../../actions/ui';
import { startLoadingUsuario, usuarioLogout } from '../../actions/usuarios';
import { ContactIcon, DownloadIcon, MessagesIcon, SectorIcon, UploadImageIcon } from '../../assets/svg/iconos';
import { ModalCambiarPassword } from './components/ModalCambiarPassword';
import { ModalEmailNotificaciones } from './components/ModalEmailNotificaciones';

export const Admin = () => {
    const dispatch = useDispatch();
    const { colores, miniLateral } = useSelector(state => state.ui);
    const { usuarios } = useSelector(state => state.usuarios);
    const { uid, empresa } = useSelector(state => state.auth);
    const { empresas } = useSelector(state => state.empresas);

    const [editMode, setEditMode] = useState(false);
    const [currentUsuario, setCurrentUsuario] = useState(null);
    const [currentEmpresa, setCurrentEmpresa] = useState(null);
    const [objUsuario, setObjUsuario] = useState({});
    const [modalCambiarPasswordOpened, setModalCambiarPasswordOpened] = useState(false);
    const [modalEmailNotificacionesOpened, setModalEmailNotificacionesOpened] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);

    useEffect(() => {
        dispatch(setMenuLateral('admin'));
        if (uid && empresa) {
            dispatch(startLoadingUsuario(uid, empresa));
        }
        return () => {
            dispatch(usuarioLogout());
        };
    }, [dispatch, uid, empresa]);

    useEffect(() => {
        if (empresas.length > 0) {
            setCurrentEmpresa(empresas[0]);
        }
    }, [empresas]);

    useEffect(() => {
        if (usuarios.length > 0) {
            setCurrentUsuario(usuarios[0]);
        }
    }, [usuarios]);

    useEffect(() => {
        if (currentUsuario?._id) {
            setObjUsuario(currentUsuario);
        }
    }, [currentUsuario]);

    const onFormChange = (e) => {
        if (!editMode) {
            return dispatch(openModalBottom({ text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3 }));
        }

        const { name, value } = e.target;
            setObjUsuario(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div
            className='admin-tab'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
        <div className='admin-wrapper'>
            <div className={`header ${!miniLateral ? 'compress' : ''}`}>
                <h1 style={{ color: colores.colorPrincipal }}>Cuenta usuario</h1>
                <div className='botonera'>
                    <div className={`slide-button ${showDownloadButton && 'show'}`}>
                        <div className='slide-item'>
                            <div className='slide-data'>
                                <UploadImageIcon color={colores.colorPrincipal} />
                                <p style={{ color: colores.colorPrincipal }}>Descargar contrato</p>
                            </div>
                        </div>
                    </div>
                    <button
                        className={`btn btn-download ${showDownloadButton && 'active'}`}
                        style={{ backgroundColor: colores.colorPrincipal }}
                        onClick={() => setShowDownloadButton(!showDownloadButton)}
                    >
                        <span className='reverse-icon'>
                            <DownloadIcon color={colores.color6} />
                        </span>
                    </button>
                </div>
            </div>

            <div className='section datos'>
                <h3 style={{ color: colores.colorSecundario }}>Datos</h3>

                <div className='datos-row row-1'>
                    <div className='datos-col col-1'>
                        <div className='data-item nombre'>
                            <label>Nombre empresa</label>
                            <input
                                type='text'
                                name='nombre'
                                value={currentEmpresa?.nombre || ''}
                                onChange={(e) => setCurrentEmpresa({ ...currentEmpresa, nombre: e.target.value })}
                                disabled={!editMode}
                            />
                        </div>
                        <div className='data-item telefono'>
                            <label>Teléfono</label>
                            <input
                                type='text'
                                name='telefono'
                                value={currentEmpresa?.telefono || ''}
                                onChange={(e) => setCurrentEmpresa({ ...currentEmpresa, telefono: e.target.value })}
                                disabled={!editMode}
                            />
                        </div>
                        <div className='data-item cif'>
                            <label>CIF/NIF</label>
                            <input
                                type='text'
                                name='cif'
                                value={currentEmpresa?.cif || ''}
                                onChange={(e) => setCurrentEmpresa({ ...currentEmpresa, cif: e.target.value })}
                                disabled={!editMode}
                            />
                        </div>
                    </div>

                    <div className='datos-col col-2'>
                        <div className='data-item email'>
                            <label>Email</label>
                            <input
                                type='email'
                                name='email'
                                value={objUsuario?.email || ''}
                                disabled
                            />
                        </div>

                        <div className='data-item password'>
                            <label>Password</label>
                            <input type='password' defaultValue={`Password`} disabled />
                        </div>

                        <div className='data-item button'>
                            <label></label>
                            <button
                                className='datos-btn'
                                style={{ color: colores.colorPrincipal }}
                                onClick={() => setModalCambiarPasswordOpened(true)}
                            >
                                Cambiar
                            </button>
                        </div>
                    </div>
                </div>

                <div className='datos-row row-2'>
                    <div className='datos-col col-3'>
                        <div className='data-item icono'>
                            <MessagesIcon />
                        </div>
                        <div className='data-item notificaciones'>
                            <label style={{ color: colores.colorPrincipal }}>Envío notificaciones</label>
                            <input
                                type='email'
                                value={currentEmpresa?.emailSMTP || ''}
                                onChange={(e) => setCurrentEmpresa({ ...currentEmpresa, emailSMTP: e.target.value })}
                                disabled={!editMode}
                            />
                        </div>
                        <button
                            className='datos-btn'
                            style={{ color: colores.colorPrincipal }}
                            onClick={() => setModalEmailNotificacionesOpened(true)}
                        >
                            Cambiar
                        </button>
                    </div>

                    <div className='datos-col col-4'>
                        <div className='data-item icono'>
                            <ContactIcon />
                        </div>
                        <div className='data-item permisos'>
                            <label style={{ color: colores.colorPrincipal }}>Permisos</label>
                            <input type='text' defaultValue={`Ver y editar (Admin)`} disabled />
                        </div>
                    </div>

                    <div className='datos-col col-5'>
                        <div className='data-item icono'>
                            <SectorIcon />
                        </div>
                        <div className='data-item sector'>
                            <label style={{ color: colores.colorPrincipal }}>Sector</label>
                            <input type='text' value={currentEmpresa?.sector?.nombre || ''} disabled />
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '20px' }}>
                    {editMode && (
                        <button
                            className='btn'
                            style={{ backgroundColor: colores.colorPrincipal, color: '#fff', marginRight: '15px', width: 'auto', minWidth: '120px', padding: '0 20px' }}
                            onClick={() => {
                                dispatch(startSaveEmpresa(currentEmpresa));
                                setEditMode(false);
                            }}
                        >
                            Guardar cambios
                        </button>
                    )}
                    <button
                        className='btn'
                        style={{ color: colores.colorPrincipal, width: 'auto', minWidth: '120px', padding: '0 20px' }}
                        onClick={() => setEditMode(!editMode)}
                    >
                        {editMode ? 'Cancelar edición' : 'Editar datos'}
                    </button>
                </div>
                </div>
            </div>

            <ModalCambiarPassword
                modalCambiarPasswordOpened={modalCambiarPasswordOpened}
                setModalCambiarPasswordOpened={setModalCambiarPasswordOpened}
            />
            <ModalEmailNotificaciones
                modalEmailNotificacionesOpened={modalEmailNotificacionesOpened}
                setModalEmailNotificacionesOpened={setModalEmailNotificacionesOpened}
            />
        </div>
    );
};
